export default function ColourSelection() {
    colourSelectionInit()
}

function colourSelectionInit() {

    var img = document.querySelector('.thumbnail img'),
        canvas = document.querySelector('#cs'),
        // result = _('.result'),
        preview = document.querySelector('.preview'),
        input = preview != null ? preview.querySelector('input') : null,
        options = document.querySelectorAll('.colour-select-options__option'),
        submitButton = document.querySelector('.colour-select__buttons button[type="submit"]'),
        resetButton = document.querySelector('.colour-select-options__reset'),
        x = '',
        y = '';

    if (img != null) {

        // preview function mousemove
        img.addEventListener('click', function (e) {
            // chrome
            if (e.offsetX) {
                x = e.offsetX;
                y = e.offsetY;
            }
            // firefox
            else if (e.layerX) {
                x = e.layerX;
                y = e.layerY;
            }

            useCanvas(canvas, img, function () {

                // get image data
                var p = canvas.getContext('2d')
                    .getImageData(x, y, 1, 1).data;
                    options.forEach(option => {
                        option.classList.remove('active');
                        option.querySelector('input').checked = false;
                    });

                // show preview color
                preview.style.background = rgbToHex(p[0], p[1], p[2]);
                preview.classList.add('active');
                submitButton.removeAttribute('disabled');
                input.checked = true;
                input.value = p[0] + ',' + p[1] + ',' + p[2]
            });
        }, false);
    }

    if (options.length > 0) {
        options.forEach(element => {
            element.addEventListener('click', function (e) {

                var elemInput = element.querySelector('input');

                if (elemInput.value != "" && elemInput.value != "on") {

                    options.forEach(option => {
                        option.classList.remove('active');
                        option.querySelector('input').checked = false;
                    });

                    element.classList.toggle("active");
                    elemInput.checked = true;
                    submitButton.removeAttribute('disabled');
                }

            });
        });
    }

    if (resetButton) {
        resetButton.addEventListener('click', function () {
            if (preview) {
                preview.classList.remove('active');
                preview.style.background = '';
                if (input) {
                    input.value = '';
                    input.checked = false;
                }
            }
            
            options.forEach(option => {
                option.classList.remove('active');
                option.querySelector('input').checked = false;
            });

            submitButton.setAttribute('disabled', 'disabled');
        });
    }



    // canvas function
    function useCanvas(el, image, callback) {
        el.width = image.width; // img width
        el.height = image.height; // img height
        // draw image in canvas tag
        el.getContext('2d')
            .drawImage(image, 0, 0, image.width, image.height);
        return callback();
    }

    // convert rgba to hex
    // http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
    function componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }

    function rgbToHex(r, g, b) {
        return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
    }
}